// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// import router from './router'
import http from './http/index'
import VueRouter from 'vue-router'
import './http/index' //接口请求
import './directive' //自定义指令
import axios from "axios";

//视图导入
import share from "./view/share.vue" 
import xyshare from "./view/xyshare.vue" 
import qcxshare from "./view/qcxshare.vue" 
import shareShow from "./view/shareShow.vue"
import qcxShareShow from "./view/qcxShareShow.vue" 
import test from "./view/test.vue" 
import spread from "./view/spread.vue"

//引入vant组件库
import Vant from 'vant';
import 'vant/lib/index.css';
//二维码插件
import VueQr from 'vue-qr';
//chart插件
import VeHistogram from 'v-charts/lib/histogram.common';
//MD5
import md5 from 'js-md5';
//引入打印工具
// import Vconsole from 'vconsole';
// new Vconsole();
import less from 'less'

Vue.use(VueQr);
Vue.use(Vant);
Vue.use(less);


//使用路由
Vue.use(VueRouter);
Vue.component(VeHistogram.name, VeHistogram)
//定义路由
//创建 router 实例
const  router = new VueRouter({
  mode: "history", //去掉地址栏的#  隐藏则为hash模式
  routes : [
    {
      path:'/',redirect:'/shareShow'
    },
    { path: '/share', component: share },
    { 
		path: '/xyshare', component: xyshare 
	},
	 { 
		path: '/qcxshare', component: qcxshare 
	},
    { 
		path: '/shareShow', component: shareShow 
		
	},
	{ 
		path: '/qcxShareShow', component: qcxShareShow 
		
	},
    { path: '/test', component: test },
    { path: '/spread', component: spread },
  ]
})



Vue.config.productionTip = false
Vue.prototype.$md5 = md5;

Vue.prototype.$http = http.service;
Vue.prototype.$api = http.API;
Vue.prototype.$BASE = http.BASE_URL;


Vue.prototype.$axios = axios;
/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// })
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js